import React, { useState } from 'react';
import { Button, Card, Container, Modal } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { FaAddressCard, FaQrcode, FaUserCheck, FaUserSlash } from "react-icons/fa6";
import { TbFileCertificate } from "react-icons/tb";
import DownloadCertificationsPopUp from './downloadCertificationsPopUp';
import { useTranslation } from 'react-i18next';
import { downloadQR } from '../../utils/downloadQr';


const ICONS = {
  FaQrcode: FaQrcode,
  FaAddressCard: FaAddressCard,
  TbFileCertificate: TbFileCertificate,
  FaUserCheck: FaUserCheck,
  FaUserSlash: FaUserSlash,

};


function CertificationsCard({ data, base64QR, icon, title, id, qrLink, openPopUp = true }) {
  const IconComponent = ICONS[icon];

  const [t] = useTranslation("companies")

  const [showLanguageDownloadPopUp, setShowLanguageDownloadPopUp] = useState(false);



  const handleShow = () => setShowLanguageDownloadPopUp(true);

  const handleClose = () => setShowLanguageDownloadPopUp(false)


  return (
    <>

      <DownloadCertificationsPopUp
        show={showLanguageDownloadPopUp}
        handleClose={handleClose}
        title={title}
        qrLink={qrLink}
        id={id}
        base64QR={base64QR}
        data={data}
      />

      <div className='mt-4 certifications-card-container'>
        <Card className='certifications-card-card custom-shadow' onClick={openPopUp ? handleShow : () => downloadQR(qrLink)}>
          <Card.Body className='certifications-card-body'>
            {IconComponent && <IconComponent size={45} className='certifications-card-icon' />}
            <div className='certifications-card-title font-bold'>{title}</div>
          </Card.Body>

        </Card>
      </div>

    </>


  );
}

export default CertificationsCard;
